export class Departamento {
    departamentoId: number;
    clave: string;
    nombre: string;
    tipoAccion?: number;
}
